module.exports = __webpack_public_path__ + "img/sacrificial-bow.4a121df8.webp";